module.exports = __webpack_public_path__ + "img/video-screen-non-logged-no.bbbbe36a.png";